export const baseDirname = "/ROOT/src";
export const baseAppDirname = `${baseDirname}/app`;
